import React from "react";
import DateTime from "./component/DateTime";
import Days from "./component/Days";
import Earning from "./component/Earning";
import CalculatePercentage from "./component/CalculatePercentage";
import CurrencyExchange from "./component/CurrencyExchange";
import DivWrapper from "./component/DivWrapper";
import "./app.css";

function App() {
  return (
    <>

    
      <DivWrapper> 
        <Days />
      </DivWrapper>
      
      <DivWrapper> 
        <DateTime />
      </DivWrapper> 
      

      <DivWrapper>
        <Earning />
      </DivWrapper>

      <DivWrapper>
        <CalculatePercentage />
      </DivWrapper>

      <DivWrapper>
        <CurrencyExchange />
      </DivWrapper>

    </>
  );
}

export default App;
